var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOn),expression:"isOn"}],staticClass:"loader-overlay"},[_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }